module.exports = {
      id: "thump-usage",
      viewBox: "0 0 58 75",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#thump",
      toString: function () {
        return this.url;
      }
    }